import { render, staticRenderFns } from "./TireFitmentLookup.vue?vue&type=template&id=54023937"
import script from "./TireFitmentLookup.vue?vue&type=script&lang=ts"
export * from "./TireFitmentLookup.vue?vue&type=script&lang=ts"
import style0 from "./TireFitmentLookup.vue?vue&type=style&index=0&id=54023937&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports